const productionBaseUrl = (window.location.origin + window.location.pathname).split('www')[0]
export const iframeBaseUrl = process.env.NODE_ENV !== 'production' ? '/toyota/dev' : productionBaseUrl

export const interColorTar={
    black:{
        label:"柔光墨",
        color:["#464646"]
    },
    white:{
        label:"缟羽白",
        color:["#CECECE"]
    },
    40:{
        label:"山吹茶",
        color:["rgb(125,96,78)"]
    },
    41:{
        label:"松鳞秋",
        color:["rgb(69,46,37)"]
    },
}
export const interPositionTar={
    main:'主驾',
    attached:'副驾',
    backR:'后排',
}

export const carConfig = {
    interSort:['white',40,'black',41],
    inter:{
        41:['main','attached','backR'],
        black:['main','attached','backR'],
        40:['main','attached','backR'],
        white:['main','attached','backR'],
    },
    defaultInter:"white",
    defaultCar:'carC1',
    car:{
        label:'颜色',
        value:[
            {"label":"玄墨银辉","value":"carC3","color":["#303030","#CECECE"]},
            {"label":"凝玉银辉","value":"carC5","color":["#E7E7E7","#CECECE"]},
            {"label":"远山银辉","value":"carC1","color":["#898989","#CECECE"]},
            {"label":"锦霞银辉","value":"carC7","color":["#CB0200",'#CECECE']},

            {"label": "玄墨一色", "value": "carC4", "color": ["#303030"]},
            {"label": "凝玉一色", "value": "carC6", "color": ["#E7E7E7"]},
            {"label": "远山一色", "value": "carC2", "color": ["#898989"]},

            {"label": "远山墨韵", "value": "carC8", "color": ["#CB0200"]}
        ]
    },

    default_wheel:'wheelM1',
    wheel: {
        label:'轮毂',
        value:[{"label": "20英寸 水镜", "value": "wheelM1"}, {"label": "22英寸 水镜", "value": "wheelM2"}, {
            "label": "22英寸 耀黑",
            "value": "wheelM3"
        }]
    },
    default_doorborder:'doorbC1',
    doorborder: {
        label:'装饰<span>门窗饰条/车顶上边梁</span>',
        value:[{"label": "银色", "value": "doorbC1"}, {"label": "黑色", "value": "doorbC2"}]
    },
    default_callipers:'callipers1',
    callipers: {
        label:'卡钳',
        value:[{"label": "黑色", "value": "callipers1"}, {"label": "红色", "value": "callipers2"}]
    }
}
